import * as yup from "yup";

export const linkToGuestySchema = yup.object({
  token: yup
    .string()
    .trim()
    .required("Please enter Guesty partner token."),
});
